// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1257":"72dded7f","2161":"72dded7f","2579":"72dded7f","3697":"72dded7f","5485":"72dded7f","6720":"72dded7f","9522":"72dded7f"}[chunkId] + ".chunk.css";
};